import * as React from 'react';

abstract class Component<P, S> extends React.Component<P, S> {
}

export default Component;


// WEBPACK FOOTER //
// ./code/foundation/components/Component.ts